import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import i18n from '@/locales'
import router from '@/router'
import '@/assets/css/tailwind.css'

Vue.config.productionTip = false

Vue.use(ElementUI);

new Vue({
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')
